import {DELETE, GET, POST} from "./api.service.wrapper";
import {apiUrl} from "../utils/constants";

export const GetPushNotification = async ( page = '', perPage = ''
        // keyword = '',
    ) => {

    let params = {};
    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    // if (keyword) {
    //     params['keyword'] = keyword;
    // }


    // params['is_paginate'] = is_paginate;
    const response = await GET(apiUrl.notification_log, params);
    return response;
}

export const GetPushNotificationById = async (id) => {
    const response = await GET(apiUrl.notification_log + '/' + id);
    return response;
}

export const CreatePushNotification = async (data) => {
    const response = await POST(apiUrl.push_notifications, data);
    return response;
}
export const DeletePushNotification = async (id) => {
    const response = await DELETE(apiUrl.push_notifications, id);
    return response;
}